import { parsePhoneNumberWithError, isValidPhoneNumber } from 'libphonenumber-js';

export const createPhoneValidator = (form: any, fieldName: string = 'number') => {
	return async (_: any, value: string) => {
		if (!value) {
			return Promise.reject('');
		}

		try {
			if (!isValidPhoneNumber(value, 'US')) {
				return Promise.reject('Please enter a valid phone number');
			}

			const phoneNumber = parsePhoneNumberWithError(value, 'US');
			form.setFieldValue(fieldName, phoneNumber.format('E.164'));

			return Promise.resolve();
		} catch (_error) {
			return Promise.reject('Please enter a valid phone number');
		}
	};
};
